import { Link } from 'react-router-dom';

const YEAR = new Date().getFullYear();

const NAV_GROUPS = [
  {
    title: 'Services',
    links: [
      { label: 'AI Solutions', href: '/services#ai-solutions' },
      { label: 'Web Applications', href: '/services#web' },
      { label: 'Windows Applications', href: '/services#windows' },
      { label: 'Mobile Applications', href: '/services#mobile' },
      { label: 'Consulting', href: '/contact' },
    ],
  },
  {
    title: 'Products',
    links: [
      { label: 'Magic Designing Software', href: '/services#products' },
      { label: 'Photo Press & Ebook', href: '/services#products' },
      { label: 'Ship Chandling System', href: '/services#products' },
      { label: 'Inventory Management', href: '/services#products' },
      { label: 'POS Solution', href: '/services#products' },
      { label: 'RFID Based Solution', href: '/services#products' },
      { label: 'RFID Library Management', href: '/services#products' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', href: '/about' },
      { label: 'Portfolio', href: '/portfolio' },
      { label: 'Industries', href: '/industries' },
      { label: 'Our Clients', href: '/clients' },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="flex items-center justify-center" style={{ width: '144px', height: '144px' }}>
                <img
                  src="https://static.readdy.ai/image/470712cea6bd611f3a1669acb3b30c19/7df20f577f8643a2dddf858949ce508a.png"
                  alt="IT Services Logo"
                  className="object-contain"
                  style={{ width: '144px', height: '144px' }}
                />
              </div>
            </div>
            {/* <p className="text-gray-500 text-sm leading-relaxed mb-5">
              25 years of empowering businesses with intelligent software solutions — from custom development to proprietary tools that drive real results.
            </p> */}
            {/* ISO Badges */}
            <div className="flex flex-col gap-2 mb-5">
              <div className="flex items-center gap-2 bg-white border border-teal-200 rounded-lg px-3 py-2">
                <i className="ri-award-line text-teal-600" />
                <span className="text-xs font-semibold text-gray-700">ISO 9001:2015 Certified</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-teal-200 rounded-lg px-3 py-2">
                <i className="ri-shield-check-line text-teal-600" />
                <span className="text-xs font-semibold text-gray-700">ISO/IEC 27001:2022 Certified</span>
              </div>
            </div>
            <div className="flex gap-3">
              {[
                { icon: 'ri-linkedin-fill', label: 'LinkedIn' },
                { icon: 'ri-twitter-fill', label: 'Twitter' },
                { icon: 'ri-facebook-fill', label: 'Facebook' },
                { icon: 'ri-mail-line', label: 'Email' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center bg-white border border-gray-200 text-gray-500 hover:bg-teal-500 hover:text-white hover:border-teal-500 rounded-lg transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav Groups */}
          {NAV_GROUPS.map((group) => (
            <div key={group.title}>
              <h5 className="text-xs font-bold text-gray-900 uppercase tracking-widest mb-5">{group.title}</h5>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-gray-500 hover:text-teal-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-10 grid sm:grid-cols-3 gap-5">
          {[
            { icon: 'ri-map-pin-line', label: 'Address', value: '401 Shukh Complex,Munsipuliya\n Indira Nagar,Lucknow,226016' },
            { icon: 'ri-phone-line', label: 'Phone', value: '+91 8853997700' },
            { icon: 'ri-mail-line', label: 'Email', value: 'info@elationsoft.net' },
          ].map((item) => (
            <div key={item.label} className="flex items-start gap-3">
              <div className="w-9 h-9 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                <i className={`${item.icon} text-base`} />
               
              </div>
              <div>
                <div className="text-xs font-semibold text-gray-400 uppercase mb-0.5">{item.label}</div>
                <div className="text-sm text-gray-700 whitespace-pre-line">{item.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            &copy; {YEAR} IT Services. All rights reserved. | 25 Years of Excellence
          </p>
          <div className="flex items-center gap-5">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((item) => (
              <a key={item} href="#" className="text-xs text-gray-400 hover:text-teal-600 transition-colors cursor-pointer">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
